import { createContext, useContext, useState, useCallback } from 'react'
import T from '../i18n/translations.js'

const LanguageContext = createContext(null)

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    // Persist language across page loads
    try { return localStorage.getItem('fa_lang') || 'en' } catch { return 'en' }
  })

  const setLang = useCallback((code) => {
    setLangState(code)
    try { localStorage.setItem('fa_lang', code) } catch {}
    // Set html[lang] for accessibility + search engines
    document.documentElement.lang = code
    // RTL support for Arabic
    document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr'
  }, [])

  // t(key) → translated string, falls back to English
  const t = useCallback((key) => {
    return (T[lang]?.[key] ?? T.en[key] ?? key)
  }, [lang])

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useLanguage must be used inside <LanguageProvider>')
  return ctx
}
